<!-- 
目前支持上传图片和视频
上传单个或者多个到oss组件（用limitNum限制可以上传几个，多个图片的上传以测试走通，多个视频未测试）
用element ui 自定义的上传图片的组件
将本地图片上传到oss，oss返回在线地址
用oss插件需要获取token等等参数，这些参数是每次上传到oss之前访问接口获得，因为它们会过期
点击裁切按钮后，裁切完自动上传到oss
可以直接点击上传按钮 
-->
<template>
  <div class="uploadFileList">
    <div class="mixtmt_upload">
      <div
        class="upload_btn"
        :class="fileList.length >= limitNum ? 'noClick' : ''"
      >
        <input
          class="uploadInput"
          :id="uploadDom_id"
          type="file"
          :accept="fileAccept"
          @change="loadFileEvent"
        />
        <div class="upload_btn_fixed">
          <span
            v-if="uploadType === 'uploadImage'"
            class="btn"
            v-text="'选择图片'"
          ></span>
          <span
            v-if="uploadType === 'uploadVideo'"
            class="btn"
            v-text="'上传视频'"
          ></span>
          <span
            v-if="uploadType === 'uploadAudio'"
            class="btn"
            v-text="'上传音频'"
          ></span>
          <span
            v-if="uploadType === 'uploadFile'"
            class="btn"
            v-text="'上传文件'"
          ></span>
          <!-- <el-button
            type="primary"
            size="small"
            :disabled="fileList.length >= limitNum"
          >
            选择图片
          </el-button> -->
        </div>
      </div>
      <div
        class="el-upload__tip"
        v-text="uploadTextTip"
        v-if="uploadTextTip"
      ></div>
      <ul class="mixtmt_uploadList">
        <li
          class="mixtmt_uploadList_li"
          v-for="file in fileList"
          :key="file.uid"
        >
          <div class="mixtmt-upload-image__preview" :class="uploadType">
            <el-image
              v-if="uploadType === 'uploadImage'"
              style="width: 4.86vw; height: 4.86vw"
              :src="file.url"
              fit="contain"
              :preview-src-list="[file.url]"
            />
            <div v-if="uploadType === 'uploadVideo'">
              <video
                :src="file.url"
                style="width: 4.86vw; height: 4.86vw"
                controls="controls"
              >
                您的浏览器不支持播放器
              </video>
            </div>
            <div v-if="uploadType === 'uploadAudio'">
              <audio :src="file.url" controls>您的浏览器不支持播放器</audio>
            </div>
            <div v-if="uploadType === 'uploadFile'">
              <span class="el-icon-document"></span>
            </div>
            <el-tooltip
              effect="dark"
              :content="computFileName(file.name)"
              placement="top-start"
              :popper-class="tooltipPopperClass ? tooltipPopperClass : ''"
              :disabled="
                computFileName(file.name).length <=
                `${uploadType === 'uploadAudio' ? 24 : 11}`
              "
            >
              <span
                class="image_name"
                v-text="
                  computFileName(file.name).length >
                  `${uploadType === 'uploadAudio' ? 24 : 11}`
                    ? `${computFileName(file.name).substring(
                        0,
                        `${uploadType === 'uploadAudio' ? 23 : 10}`
                      )}...`
                    : computFileName(file.name)
                "
              ></span>
            </el-tooltip>
            <span class="elProgress_box">
              <el-progress
                v-show="file.status === 'progress'"
                :percentage="file.percentage"
              />
            </span>

            <span class="elButton_box" :class="[uploadType, file.status]">
              <el-button
                v-if="uploadType === 'uploadImage'"
                type="primary"
                class="el-icon-crop"
                size="small"
                circle
                @click="cropPreview(file)"
              />
              <el-button
                v-if="file.status !== 'progress' && file.status !== 'success'"
                type="success"
                class="el-icon-upload"
                size="small"
                circle
                @click="loactionPreview(file)"
              />
              <el-button
                type="danger"
                class="el-icon-close"
                size="small"
                circle
                @click="removePreview(file)"
              />
            </span>
            <span
              class="item_stateIcon success"
              v-if="file.status === 'success'"
            >
              <i class="el_icon__upload_success">
                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="currentColor"
                    d="M406.656 706.944 195.84 496.256a32 32 0 1 0-45.248 45.248l256 256 512-512a32 32 0 0 0-45.248-45.248L406.592 706.944z"
                  ></path>
                </svg>
              </i>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <div class="cropperPop" v-if="showCropperPop">
      <VueCropper
        :imgFile="editFile.url"
        :uploadImageType="uploadImageType"
        @closeCropper="closeCropperHandler"
        @upload="uploadHanlder"
      ></VueCropper>
    </div>
  </div>
</template>

<script>
import VueCropper from '@/components/base/VueCropper.vue'
import ossPutObject from '@/utils/upload_oss.js'
import { https_getOssUploadInfor } from '@api/platfrom_base_api.js'
export default {
  name: 'UploadFileList',
  components: { VueCropper },
  props: {
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => {
        return {
          value: '',
          key: '',
        }
      },
    },
    uploadType: {
      type: String,
      default: 'uploadImage',
    },
    uploadTextTip: {
      type: String,
      default:
        'jpg/png 文件不能大于100M（最多上传1张，当该字段只展示一张图片时优先取第一张）',
    },
    limitNum: {
      // 限制可以上传几张图片
      type: Number,
      default: 50,
    },
    tooltipPopperClass: {
      type: String,
      default: '',
    },
    customUploadCallback: {
      type: [Function, null],
      default: null,
    },
  },
  data() {
    return {
      uploadDom_id: '',
      uploadDom: null,
      fileList: [
        // 这个是数组，可以存储单张或者多张图片；单张图片向父级返回单张图片字符串地址；多张图片向父级返回多张地址数组.join(this.jionUrlSymbols)的字符串
        // {
        //   name: '麦克风.jpg',
        //   percentage: 100,
        //   status: 'success', //'location':刚从本地读取文件到浏览器未上传； 'progress':正在向oss上传；'success':已经上传成功
        //   size: 24531,
        //   raw: {},
        //   uid: 1678249363302,
        //   url: '',
        //   submitVal: 'hyper/%E9%BA%A6%E5%85%8B%E9%A3%8E.jpg', //不要oss域名的路径
        //   absOssUrl:
        //     'http://mixtmt-images.oss-cn-beijing.aliyuncs.com/hyper/%E9%BA%A6%E5%85%8B%E9%A3%8E.jpg', //oss生产的在线地址
        // },
      ],
      showCropperPop: false,
      editFile: { url: '' },
      uploadImageType: 'all',
      jionUrlSymbols: ',', //用来区分多个图片链接的符号 this.item.value: 'url1'||'url1,url2,url3'
    }
  },
  watch: {
    item: {
      // 在collapseForm.vue页面点击提交时，这里传递数据
      handler(newVal, oldVal) {
        console.debug('item.value:', newVal)
        let fileList = []
        if (newVal.value) {
          let urlArr = []
          if (newVal.value.indexOf(this.jionUrlSymbols)) {
            urlArr = newVal.value.split(this.jionUrlSymbols)
          } else {
            urlArr.push(newVal.value)
          }
          urlArr.forEach((item) => {
            fileList.push(this.computFileItem(item, newVal.key))
            // 超赛上传oss文件，文件名uuid命名
          })
          console.debug('urlArr:', urlArr)
        }
        this.fileList = fileList
        console.debug('fileList:', fileList)
      },
      immediate: true,
    },
  },
  computed: {
    fileAccept() {
      let accept = ''
      if (this.uploadType === 'uploadImage') {
        accept = '.jpg,.jpeg,.png,.git,.webp,.heic'
      } else if (this.uploadType === 'uploadVideo') {
        accept = '.avi,.mp4,.3gp,.mkv,.mpg,.mpeg,.rmvb,.wmv,.flv,.mov' //.ts,
      } else if (this.uploadType === 'uploadAudio') {
        accept = '.mp3,.wma,.wav,.aac,.ra,.m4a,.flac,.ape,.ac3,.amr,.caf,.acm'
      } else if (this.uploadType === 'uploadFile') {
        accept = '.xlsx, .pdf, .txt, .doc, .docx, .xls, .rar, .zip,'
      }
      return accept
    },
  },
  created() {
    this.uploadDom_id = this.guid('m-upload-file-xxxxxx-4xxx-yxxx')
  },
  mounted() {},
  methods: {
    loadFileEvent(event) {
      console.debug(event)
      if (!this.uploadDom) {
        this.uploadDom = document.getElementById(this.uploadDom_id)
      }
      const file = this.uploadDom.files[0]
      this.uploadDom.value = ''
      this.packageFileList(file)
    },
    guid(format) {
      // 'm-upload-file-xxxxxx-4xxx-yxxx'
      return format.replace(/[x,y]/g, function (c) {
        let r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    computFileItem(itemUrl, name) {
      let pathArr = itemUrl.split('?')
      let type = pathArr[0].split('.').pop()
      return {
        status: 'success',
        name: `${name}.${type}`,
        url: itemUrl,
        submitVal: itemUrl,
      }
    },
    computFileName(fileName) {
      console.debug(fileName)
      const fileNameArr = fileName.split('?')
      return fileNameArr[0]
    },
    closeCropperHandler() {
      // 关闭图片裁切弹窗
      this.clickUploadBtn(true)
    },
    uploadHanlder(imageDataObj) {
      // 保存裁切图片
      console.debug(
        'uploadHanlder:',
        imageDataObj,
        this.fileList,
        this.editFile
      )
      return

      let dataFile = this.dataURLtoFile(imageDataObj.base64, this.editFile.name)
      if (this.fileList && this.fileList.length > 0) {
        this.fileList.forEach((item) => {
          if (item.uid === this.editFile.uid) {
            item.url = imageDataObj.base64
            item.percentage = 20
            item.status = 'progress'
            item.size = dataFile.size
            item.raw = dataFile
          }
        })
      }

      //   console.debug(dataFile)
      this.uploadToOss(dataFile)
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(this.jionUrlSymbols),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = window.atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    clickUploadBtn(flag) {
      this.showCropperPop = !flag
    },
    async uploadToOss(data) {
      // const query = this.$route.query
      let params = null
      let pathUrl = null
      await https_getOssUploadInfor(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          console.debug('https_getOssUploadInfor:', res)
          // 上传到oss
          params = {
            // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
            region: 'oss-cn-beijing',
            // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
            accessKeyId: res.data.accessKeyId, //'STS.NTGB8nQVfw2FgqhHiTCp2YnBU',
            accessKeySecret: res.data.accessKeySecret, //'DtvoZfCR7kyEs1eg8dyzzmXEeNCbFHbnEJUmFxJmCgXP',
            // 从STS服务获取的安全令牌（SecurityToken）。
            stsToken: res.data.securityToken,
            // 填写Bucket名称。
            bucket: res.data.bucketName,
          }
          if (res.data.folder && res.data.bucketName) {
            let type = this.editFile.name.split('.')[1]
            let name = this.guid('m-platfrom-upload-file-xxxxxx-vxxx-4xxx')
            pathUrl = `${res.data.folder}/${name}.${type}`
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      if (params && pathUrl) {
        await ossPutObject(
          params,
          data,
          pathUrl,
          this.uploadOssSuccess,
          this.uploadOssErr
        )
        // 上传完之后关闭弹窗
        this.closeCropperHandler()
      }
    },
    uploadOssSuccess(data, pathUrl, signUrl) {
      console.debug('uploadOssSuccess:', data, pathUrl, signUrl)
      if (this.fileList && this.fileList.length > 0) {
        this.fileList.forEach((item) => {
          if (item.uid === this.editFile.uid) {
            item.submitVal = pathUrl //后端只要不含oss域名路径的地址路径
            item.percentage = 100
            item.status = 'success'
            item.ossUrl = signUrl //oss生产的线上路径并且带签名
          }
        })
      }
      console.debug('this.fileList:', this.fileList)
      if (this.fileList && this.fileList.length === 1) {
        this.$emit('submitImageEvent', {
          absOssUrl: pathUrl,
          fullOssUrl: signUrl,
          uploadFileItem: this.item,
        })
      }
      if (this.fileList && this.fileList.length > 1) {
        let absUrlArr = [],
          fullUrlArr = []
        this.fileList.forEach((item) => {
          absUrlArr.push(item.submitVal)
          fullUrlArr.push(item.ossUrl)
        })
        this.$emit('submitImageEvent', {
          fullOssUrl: fullUrlArr.join(this.jionUrlSymbols),
          absOssUrl: absUrlArr.join(this.jionUrlSymbols),
          uploadFileItem: this.item,
        })
      }
    },
    uploadOssErr(err) {
      console.debug('uploadOssErr:', err)
    },
    handleRemove(uploadFile, uploadFiles) {
      console.debug('handleRemove:', uploadFile, uploadFiles)
    },
    removePreview(file) {
      let fileList = []
      if (this.fileList && this.fileList.length > 0) {
        this.fileList.forEach((item) => {
          if (item.uid !== file.uid) {
            fileList.push(item)
          }
        })
        this.fileList = fileList
      }
      let data = ''
      if (fileList.length === 0) {
        data = ''
      } else {
        let urlArr = []
        fileList.forEach((item) => {
          urlArr.push(item.url)
        })
        data = urlArr.join(this.jionUrlSymbols)
      }
      this.$emit('submitImageEvent', {
        fullOssUrl: data,
        absOssUrl: data,
        uploadFileItem: this.item,
      })
    },
    loactionPreview(file) {
      // 本地上传
      console.debug('loactionPreview:', file)
      if (this.customUploadCallback) {
        this.customUploadCallback(file)
      } else {
        let newFile = JSON.parse(JSON.stringify(file))
        newFile.name = this.computFileName(file.name)
        this.editFile = newFile
        if (this.fileList && this.fileList.length > 0) {
          this.fileList.forEach((item) => {
            if (item.uid === this.editFile.uid) {
              item.percentage = 40
              item.status = 'progress'
            }
          })
        }
        this.uploadToOss(file.raw)
      }
    },
    async packageFileList(file) {
      console.debug(file)
      const url = await this.fileToBase64Async(file)
      this.fileList.push({
        name: file.name,
        percentage: 0,
        status: 'location',
        size: file.size,
        raw: file,
        uid: this.guid('image-xxxx-xxxx-xxxx'),
        url,
        submitVal: '',
        absOssUrl: '',
      })
    },
    async fileToBase64Async(file) {
      // param {File} file
      return new Promise((resolve) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => {
          resolve(e.target.result)
        }
      })
    },
    cropPreview(file) {
      // 裁切上传
      console.debug('cropPreview:', file)
      let newFile = JSON.parse(JSON.stringify(file))
      newFile.name = this.computFileName(file.name)
      this.editFile = newFile
      this.showCropperPop = true
    },
  },
}
</script>

<style scoped lang="scss">
.uploadFileList {
  width: 100%;
  .cropperPop {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1000;
    width: 100vw;
    height: calc(100vh - 3.47vw);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    transform: translate(-50%, -50%);
    & > div {
      width: 100%;
    }
  }
  .mixtmt_upload {
    /* padding-top: 0.347vw; */
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    .upload_btn {
      position: relative;
      width: 6.94vw;
      height: 1.83vw;
      padding-left: 0.278vw;
      border-radius: 0.278vw;
      overflow: hidden;
      &.noClick .upload_btn_fixed {
        pointer-events: all;
        cursor: no-drop;
        background-color: var(--mixtmt_greyColor8);
        color: var(--mixtmt_greyColor2);
      }
      &.noClick .uploadInput {
        pointer-events: none;
      }
      .uploadInput {
        margin-left: -5.208vw;
        font-size: 0.833vw;
        cursor: pointer;
      }
      .upload_btn_fixed {
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 100%;
        background-color: var(--mixtmt_mainColor6);
        color: var(--mixtmt_whiteColor);
        text-align: center;
        border-radius: 0.278vw;
        overflow: hidden;

        .btn {
          display: block;
          font-size: 0.833vw;
          line-height: 1.83vw;
        }
      }
    }
    .el-upload__tip {
      padding-bottom: 0.694vw;
    }
    .mixtmt_uploadList {
      padding: 0;
      width: 100%;
      list-style: none;
      position: relative;
      .mixtmt_uploadList_li {
        overflow: hidden;
        z-index: 0;
        background-color: var(--mixtmt_whiteColor);
        border: 1px solid var(--mixtmt_greyColor8);
        border-radius: 0.416vw;
        box-sizing: border-box;
        margin-top: 0.694vw;
        padding: 0.694vw;
        display: flex;
        align-items: center;
        transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
        font-size: 0.972vw;
        color: var(--mixtmt_greyColor2);
        margin-bottom: 0.347vw;
        position: relative;
        width: 100%;
        .mixtmt-upload-image__preview {
          position: relative;
          width: 100%;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.972vw;
          &.uploadAudio {
            padding: 0 0 2.083vw 0;
            .image_name {
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 2;
              width: 50%;
            }
            .elProgress_box {
              position: absolute;
              bottom: 0;
              right: 0;
              z-index: 2;
              width: 50%;
            }
          }
          .image_name {
            width: 8.333vw;
            padding: 0 0.694vw;
          }
          .elProgress_box {
            flex: 1;
          }
          .elButton_box {
            width: 6.94vw;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-end;
            align-items: center;
            padding-right: 0.694vw;
            &.uploadVideo.progress,
            &.uploadVideo.success {
              width: 3.472vw;
            }
          }
          .item_stateIcon {
            position: absolute;
            right: -1.875vw;
            top: -1.18vw;
            width: 3.194vw;
            height: 1.805vw;
            text-align: center;
            transform: rotate(45deg);
            &.success {
              display: block;
              background: var(--mixtmt_successColor);
              .el_icon__upload_success {
                color: #fff;
              }
            }
            .el_icon__upload_success {
              display: block;
              font-size: 0.833vw;
              margin: 0.625vw 0 0 0.2778vw;
              transform: rotate(-45deg);
              svg {
                height: 1em;
                width: 1em;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-upload-list__item {
  padding: 0 !important;
  .el-progress__text {
    top: 50%;
    transform: translateY(-50%);
  }
}
.uploadFileList {
  .el-icon-crop:before {
    font-size: 0.833vw;
  }
  .el-button--small.is-circle {
    padding: 0.347vw;
    font-size: 0.833vw;
  }
  .el-progress--line {
    .el-progress__text {
      font-size: 0.974vw !important;
    }
  }
}
.uploadAudio {
  .el-progress-bar {
    padding-right: 3.66667vw;
    margin-right: -4.33333vw;
  }
}
.programList {
  &.el-tooltip__popper {
    z-index: 1650 !important;
    font-size: 0.833vw;
    border-radius: 0.347vw;
    padding: 0.694vw;
  }
}
</style>
